import InstagramIcon from '@mui/icons-material/Instagram';
import YouTubeIcon from '@mui/icons-material/YouTube';
import TwitterIcon from '@mui/icons-material/X';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import LanguageIcon from '@mui/icons-material/Language';
import EmailIcon from '@mui/icons-material/Email';
import Stack from '@mui/material/Stack';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';

export const SocialStack = () => {
    return (
        <Stack direction="row" spacing={2} justifyContent="center">
            <Tooltip title="Instagram">
                <IconButton href="https://www.instagram.com/tricsconsortium" target="_blank">
                    <InstagramIcon />
                </IconButton>
            </Tooltip>
            <Tooltip title="YouTube">
                <IconButton href="https://www.youtube.com/@trics89" target="_blank">
                    <YouTubeIcon />
                </IconButton>
            </Tooltip>
            <Tooltip title="X / Twitter">
                <IconButton href="https://x.com/trics89" target="_blank">
                    <TwitterIcon />
                </IconButton>
            </Tooltip>
            <Tooltip title="LinkedIn">
                <IconButton href="https://www.linkedin.com/groups/4988023/" target="_blank">
                    <LinkedInIcon />
                </IconButton>
            </Tooltip>
            <Tooltip title="Bluesky">
                <IconButton href="https://bsky.app/profile/trics89.bsky.social" target="_blank">
                    <LanguageIcon />
                </IconButton>
            </Tooltip>
            <Tooltip title="Mailchimp">
                <IconButton href="https://trics.us12.list-manage.com/subscribe?u=20a0a619c3edc88a52d35b9fc&id=d0918b5263" target="_blank">
                    <EmailIcon />
                </IconButton>
            </Tooltip>
        </Stack>
    );
};
